export class UploadedFile {
  name: string;
  size: number;
  progress = 0;
  error = '';

  constructor(name: string, size: number) {
    this.name = name;
    this.size = size;
  }

  get sizeProgress(): number {
    return this.size * (this.progress / 100);
  }

  get complete(): boolean {
    return this.progress === 100;
  }
}
